<template>
    <div class="mt-3">
        <base_location_modal key="standart" :tabs_advanced="this.filter_tabs(tabs_add)">

            <template v-slot:location_general_info="{ location, name }">
                <pwa_general_tab :location="location"></pwa_general_tab>
            </template>

            <template v-slot:pwa_location_image="{ location, name }">
                <pwa_location_image :location="location"></pwa_location_image>
            </template>

            <!--
            <template v-slot:pwa_payment_tab="{ location, name }">
                <pwa_payment_tab :location="location"></pwa_payment_tab>
            </template>
            -->

            <template v-slot:pwa_qr_tab="{ location, name }" >
                <pwa_qr_tab :show_sections="false" :location="location" ></pwa_qr_tab>
            </template>






        </base_location_modal>
    </div>
</template>

<script>
import base_location_modal from "../../base/location_modal/base_location_modal";
import pwa_general_tab from "./tabs/pwa_general_tab";
import pwa_location_image from "./tabs/pwa_location_image";
import pwa_payment_tab from "./tabs/pwa_payment_tab";
import pwa_qr_tab from "./tabs_qr/pwa_qr_tab.vue";


export default {
    name: "pwa_location_modal",
    components : {
        pwa_general_tab,
        base_location_modal,
        pwa_location_image,
        pwa_payment_tab,
        pwa_qr_tab
    },

    data () {
        return {

            tabs_add : [
                {
                    index : "pwa_location_image",
                    title : this.__t('PWA_IMAGE'),
                },

             /*   {
                    index : "pwa_payment_tab",
                    title : this.__t('PWA_PAYMENT'),
                },*/

                {
                    index : "pwa_qr_tab",
                    title : this.__t('PWA_QR'),
                }

            ]
        }
    },
    methods : {


        filter_tabs(tabs) {
            console.log(this);

            return tabs;
        },

        set_active(tab) {

        },

        get_tab_title(tab) {

        }
    },
    computed: {
    }
}
</script>

<style scoped>

</style>
